import React, { Component } from 'react';
import './BrowserNotSupportedMessage.css';
import { getTranslation, getCurrentLang, setLanguage } from '../../assets/creator/translations';
import LanguageSelector from '../LanguageSelector/LanguageSelector';

class BrowserNotSupportedMessage extends Component {
    constructor(props) {
        super(props);
        this.state = { lang: getCurrentLang(), isMenuOpen:false, }
    }

    changeLanguage = (newLang) => {
        setLanguage(newLang);
        this.setState({ lang: newLang });
    }

    render = () => (
        <div className="browser-not-supported">
                <Logo />
                <BrowserList />
                <div className="langs">
                    <LanguageSelector
                        lang={this.state.lang}
                        langChangeHandler={this.changeLanguage}
                    />
                </div>
        </div>
    );
}


export default BrowserNotSupportedMessage;

const Logo = () => (
        <div className="logo">
            <img className="logo__img" src="./img/comarch-logo.png" alt="logo" />
        </div>
)

const BrowserList = () => (
    //disable eslint warning for link messages in browser-logo links
    <div className="browsers">
            <h4>{getTranslation("BrowserNotSupported")}</h4>
            <p className='browsers_p'>{getTranslation("UseOneOfBrowsersBelow")}</p>
            <div className='browser-section'>
                <div className='browser-container c'>
                    <a href="https://www.google.com/chrome" aria-label="Google Chrome"/>
                    <p>{getTranslation("mobileVersion")} 46</p>
                </div>
                <div className='browser-container f'>
                    <a href="https://www.mozilla.org/firefox/" aria-label="Mozilla Firefox"/>
                    <p>{getTranslation("mobileVersion")}42</p>
                </div>
                <div className='browser-container o'>
                    <a href="https://www.opera.com/pl/download" aria-label="Opera"/>
                    <p>{getTranslation("mobileVersion")}50</p>
                </div>                
                <div className='browser-container e'>
                    <a href="https://www.microsoft.com/microsoft-edge" aria-label="Microsoft Edge"/>
                    <p>{getTranslation("mobileVersion")}12</p>
                </div>               
                <div className='browser-container s'>
                    <a href="https://support.apple.com/HT204416" aria-label="Safari"/>
                    <p>{getTranslation("mobileVersion")}11</p>
                </div>
            </div>


			<span className="border-line"></span>
    </div>
)